module.exports = __webpack_public_path__ + "static/img/Tech_03.f1e1861b.png";